import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_BROADCASTERS = "special_initiatives_get_broadcasters";

@Component
export default class BroadcastersMixin extends Vue {
  index() {
    const path = `${API_ENDPOINT}/special_initiatives/broadcasters.json`;
    return this.$store.dispatch("http/request", {
      tag: GET_BROADCASTERS,
      url: path,
      method: "GET",
    });
  }
}
